import script from "./PortalWorkspaceLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalWorkspaceLoader.vue?vue&type=script&setup=true&lang=js"

import "./PortalWorkspaceLoader.vue?vue&type=style&index=0&id=d6ad6a2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6ad6a2e"]])

export default __exports__